"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SuitcaseIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M17 14h2V9H5v5h2v-1a1 1 0 0 1 2 0v1h6v-1a1 1 0 0 1 2 0zm0 2v1a1 1 0 0 1-2 0v-1H9v1a1 1 0 0 1-2 0v-1H5v3h14v-3zM9 7h6V6H9zM7 7V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2z"/></svg>`
}, props));
SuitcaseIcon.displayName = 'SuitcaseIcon';
var _default = exports.default = SuitcaseIcon;